import { Box, Typography, capitalize } from "@mui/material";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Reservation } from "models/Reservation";
import { TableState } from "models/Table";
import { getHoursFormatted } from "modules/reservations/helpers/date/getHoursFormatted";

import { ReservationsContext } from "../Reservations";


export function Messages(): ReactElement {
    const { t } = useTranslation();
    const { reservationsControl: { tablesState } } = useContext(ReservationsContext);

    const reservationsMap = (tablesState ?? [])
        .reduce((reservations: Record<string, { reservation: Reservation, tableStates: Array<TableState> }>, tableState: TableState) => {
            tableState.reservations
                .filter(({ message }) => message?.length)
                .forEach((reservation: Reservation) => {
                    if (!reservations[reservation.id]) {
                        reservations[reservation.id] = {
                            reservation,
                            tableStates: [],
                        };
                    }
                    reservations[reservation.id].tableStates.push(tableState);
                });

            return reservations;
        }, {});

    return (
        <>
            {
                Object.values(reservationsMap)
                    .map((reservation: { reservation: Reservation, tableStates: Array<TableState> }) =>
                        <Box
                            key={reservation.reservation.id}
                            sx={{ my: 1 }}
                        >
                            <Typography
                                sx={{ fontWeight: "bold" }}
                                variant="h3"
                            >
                                { capitalize(t("modules.reservations.table")) } { reservation.tableStates.map((tableState: TableState) => tableState.tableNum).join(", ") }:
                            </Typography>
                            <Box sx={{ my: .5 }}>
                                <Typography>
                                    <span style={{ fontWeight: "bold" }}>{ capitalize(t("modules.reservations.hours")) }: </span>
                                    <span>{ getHoursFormatted(reservation.reservation.start, reservation.reservation.end) }</span>
                                    <span> / </span>
                                    <span style={{ fontWeight: "bold" }}>{ capitalize(t("modules.reservations.nameAndSurname")) }: </span>
                                    <span>{ reservation.reservation.name || `@${ reservation.reservation.instagram }` }</span>
                                    <span> / </span>
                                    <span style={{ fontWeight: "bold" }}>{ capitalize(t("modules.reservations.comment")) }: </span>
                                    <span>{ reservation.reservation.message }</span>
                                </Typography>
                            </Box>
                        </Box>,
                    )
            }
        </>
    );
}